import { apiSah } from '~constants/api';

import { get } from '~libs/genericAction';
import { createThunks } from '~libs/reduxUtils';

export const typePrefix = 'sah-classifications';

const config = [{ actionType: 'getAll', apiPath: `${apiSah}/classifications`, method: get }];

export const { getAll } = createThunks(typePrefix, config);
